const axios = require('axios');
import etService from '@/services/emailTemplate.service'; 
import Formatter from '@/functions/Formatter';
const isDevEnv = process.env.NODE_ENV === 'development';

const SendGrid = axios.create();
const BASE_URL = isDevEnv ? "http://localhost:8081" : window.location.origin;

async function sendEmail(templateIdentifier, toAddress, substitutionFields, needAuth = true){
    let userData = localStorage.getItem('user');
    if (userData && needAuth)
        userData = JSON.parse(userData);
    else if(!userData && needAuth)
        return {};

    try{
        const templateResponse = await etService.getOneByIdentifier(templateIdentifier);
        const emailTemplate = Formatter.formatEmailTemplate(templateResponse.data);
        const body = {
            to: toAddress,
            from: emailTemplate.from_sender,
            subject: emailTemplate.subject,
            dynamic_template_data: substitutionFields
        };
        if(emailTemplate.template_id)
            body.templateId = emailTemplate.template_id;

        const endpoint = BASE_URL + "/email/";
        
        const response = await SendGrid.post(endpoint, body, {
            headers: {
                template_id: emailTemplate.id,
                jwtToken: userData?.jwt
            }
        });
        return response;
    }
    catch(e){
        console.log(e);
    }
}

export default{
    sendEmail
}
